import { AfterViewInit, AfterViewChecked, Directive, OnDestroy, HostListener } from '@angular/core';

declare var $: any; // TODO: remove this line and fix the errors
const TOC_LINK_SELECTOR = 'nav#table-of-contents-nav  ul > li > a';
// These adjustments are needed to tweak the look of things
const SCROLL_BASE_ADJUSTMENT = 10;
const SCROLL_DURATION_MS = 400;

@Directive({
  selector: '[appTableOfContents]'
})
export class TableOfContentsDirective implements AfterViewInit, AfterViewChecked, OnDestroy {

  constructor() { }

  public ngAfterViewInit() {
    // detect/reset margins or sticky class first
    this.resetHeightOrMargins();

    this.extendScrollSpy();

    // Add scrollspy
    $('body').addEnhancedScrollspy({ target: '#table-of-contents-nav', offset: this.getTableOfContentsOffset()});

    // Add smooth scrolling to all links
    $(TOC_LINK_SELECTOR).on('click', (event) => {
      const hash = event.target.hash;
      if (hash) {
        event.preventDefault(); // Prevent default anchor click behavior

        const animationOffset = this.getAnimationOffset(hash);

        // Use jQuery's animate() method to add smooth page scroll
        $('html, body').animate({
          scrollTop: $(hash).offset().top - animationOffset
        }, SCROLL_DURATION_MS);
      } // End if
    });
  }

  // detect sub-menu links, if found add to offset so header doesn't overlap subsection name
  private getAnimationOffset(hash: string): number {
    let animationOffset = this.getTableOfContentsOffset() - SCROLL_BASE_ADJUSTMENT;

    const tocLink = $('a[href="' + hash + '"]');
    const additionalOffset = tocLink.attr('data-scrollspy-offset-px');
    if (additionalOffset) {
      animationOffset += Number(additionalOffset);
    }
    return animationOffset;
  }

    /**
   * listener to window size change event
   * @param
   */
  @HostListener('window:resize', ['$event'])
  onResize($event) {
    this.resetHeightOrMargins();
    this.updateScrollspyOffset();
  }

  public ngAfterViewChecked() {
    this.resetHeightOrMargins();
    this.updateScrollspyOffset();
  }

  private updateScrollspyOffset() {
    const scrollspy = $('body').data('enhancedScrollSpy');
    scrollspy.options.offset = this.getTableOfContentsOffset();
    scrollspy.process();
  }

  public ngOnDestroy() {
    $(TOC_LINK_SELECTOR).off('click');
    $('body').removeData('enhancedScrollSpy');
  }

  // This approach lets us exclude certain target ids from causing scrollspy to activate the toc <li>
  // This is necessary because the "What do I owe?" and "Judgment Abstracts" have overlapping targets in civil
  // https://stackoverflow.com/questions/13766381/exclude-id-in-twitter-bootstrap-scrollspy/13788899#13788899
  private extendScrollSpy(): void {
    // save the original function object
    const originalScrollSpy = $.fn.scrollspy;

    // create a new constructor
    const EnhancedScrollSpy = function(element, options) {
        originalScrollSpy.Constructor.apply( this, arguments );
    };

    // extend prototypes and add a super function
    EnhancedScrollSpy.prototype =
      $.extend({},
        originalScrollSpy.Constructor.prototype,
        {
          constructor: EnhancedScrollSpy,
          activate: function (target) {
            if (!this.excludedTargets) {
              this.excludedTargets = this.getExcludedTargets();
            }

            // if target is on our exclusion list, prevent the scrollspy to activate
            if (this.excludedTargets.indexOf(target) !== -1) {
              return;
            }
            const args = $.makeArray(arguments);
            originalScrollSpy.Constructor.prototype.activate.apply(this, args);
          },
          getExcludedTargets: function() {
            const exclusionList = [];
            const $scrollspy = $(this)[0];

            for (const t of $scrollspy.targets) {
              const tocLink = $('a[href="' + t + '"]');
              const exclude = tocLink.hasClass('toc-activate-exclude');
              if (exclude) {
                exclusionList.push(t);
              }
            }
            return exclusionList;
          }
      });

      $.fn.addEnhancedScrollspy = function(options) {
        const enhancedScrollspy = new EnhancedScrollSpy(this, options);
        $('body').data('enhancedScrollSpy', enhancedScrollspy);
      };
  }

  /**
   * set margin-top and padding-top of main-content and table-of-contents-nav-list
   */
  private resetHeightOrMargins() {
    const scrollspyOffsetDiv = $('.table-of-contents-header-offset')[0];
    const titleHeight = scrollspyOffsetDiv.offsetHeight;
    const mainContent = $('.main-content');
    mainContent.css('margin-top', titleHeight);

    const navList  = $('#table-of-contents-nav-list');
    navList.css({'padding-top': (titleHeight + 77) + 'px'}); // Adjust 77px
  }

  private getTableOfContentsOffset(): number {
    const navListElement = $('#table-of-contents-nav-list')[0];
    const navList = $(navListElement);
    return (navList.innerHeight() - navList.height()) - 5; // Adjust 5px
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/table-of-contents.directive.ts